import React, { useContext } from "react";
import { Container, Drawer, Flex, Heading, MLink, Text } from "@cisco/spaces-dash-lib-styleguide";
import { I18nContext } from "../../contexts/i18nContext";
import TechSupportImage from "../../assets/images/icons/tech-support.svg";

interface ContactUsProps {
  isOpen: boolean;
  closeModal: () => void;
}

export function ContactUs(props: ContactUsProps): JSX.Element {
  const { isOpen, closeModal } = props;
  const i18n = useContext(I18nContext);

  if (!i18n) {
    throw new Error("I18nContext is not available");
  }

  const { t } = i18n;

  return (
    <Drawer isOpen={isOpen} size="md" onClose={closeModal}>
      <Drawer.Heading>
        <Heading>{t("partner-apps.partner-app-activation.support-text", { ns: "spaces-dash-app-partners-login" })}</Heading>
      </Drawer.Heading>
      <Container.Well style={{ marginTop: "12px", padding: "16px" }}>
        <Flex gap={12} direction="vertical">
          <Flex gap={16} justify="space-between">
            <Flex gap={16}>
              <img height={30} src={TechSupportImage} alt="Tech Support" />
              <Text size="p1" weight="semi-bold">
                {t("auth.login.login-partner-base.general-support-text", { ns: "spaces-dash-app-partners-login" })}
              </Text>
            </Flex>
            <MLink href="https://mycase.cloudapps.cisco.com/trial" target="_blank">
              {t("auth.login.login-partner-base.open-case-text", { ns: "spaces-dash-app-partners-login" })}
            </MLink>
          </Flex>
          <Text>{t("auth.login.login-partner-base.support-description-text", { ns: "spaces-dash-app-partners-login" })}</Text>
          <Flex>
            <MLink href="http://spaces.cisco.com/support/" target="_blank">
              {t("auth.login.login-partner-base.know-more-text", { ns: "spaces-dash-app-partners-login" })}
            </MLink>
          </Flex>
        </Flex>
      </Container.Well>
    </Drawer>
  );
}
